import { render, staticRenderFns } from "./BaseDesignPaperSamplePage.vue?vue&type=template&id=3b0c9210&"
import script from "./BaseDesignPaperSamplePage.vue?vue&type=script&lang=js&"
export * from "./BaseDesignPaperSamplePage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports